import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNotdef } from "@fortawesome/free-solid-svg-icons";
import { fetchJson } from "../utils/fetchJson";

const YoungEditorialPage = () => {
  const [allMembers, setAllMembers] = useState([]); 
  const [filteredMembers, setFilteredMembers] = useState([]); 
  const [currentHash, setCurrentHash] = useState(''); 
  const [title, setTitle] = useState(''); 
  const [cover, setCover] = useState(''); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 监听URL哈希值变化
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      setCurrentHash(hash);
    };

    // 初始化哈希值
    handleHashChange();
    
    // 监听哈希变化事件，实现动态更新
    window.addEventListener('hashchange', handleHashChange);
    
    // 组件卸载时移除事件监听
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // 获取JSON数据
  useEffect(() => {
    fetchJson('/json/editorialMembers.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('数据获取失败: ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        // 确保数据以数组形式存储
        setAllMembers(Array.isArray(data) ? data : [data]);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // 根据哈希值筛选数据
  useEffect(() => {
    if (allMembers.length > 0 && currentHash) {
      // 查找与当前哈希值匹配的id数据
      const matchedData = allMembers.find(item => item.id === currentHash);
      setTitle(matchedData?.title || '');
      setCover(matchedData?.cover_img || '');
      setFilteredMembers(matchedData?.data || []);
    } else {
      setFilteredMembers([]);
      setTitle('');
      setCover('');
    }
  }, [allMembers, currentHash]);

  if (loading) {
    return (
      <div className="container mt-4 d-flex justify-content-center align-items-center min-vh-50">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4 alert alert-danger" role="alert">
        错误: {error}
      </div>
    );
  }

  // 检查是否有匹配的数据
  const hasData = filteredMembers.length > 0;

  return (
    <div className='container mt-4 fade-in-up'>
      <div className="mb-6">
        <h1 className="page-title mb-4">Young Editorial Board Member</h1>
      </div>
      
      {hasData ? (
        // 有匹配数据时使用栅格布局
        <div className="row gap-6 mb-4">
          <div className="col-lg-4 col-md-12">
            <div>
              <div className="cover-image-container rounded shadow-sm overflow-hidden border">
                {cover ? (
                  <img 
                    src={cover} 
                    alt={title} 
                    className="img-fluid" 
                    style={{ 
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center bg-light" style={{ height: '300px' }}>
                    <FontAwesomeIcon icon={faNotdef} size="3x" className="text-gray-400" />
                  </div>
                )}
              </div>
              {/* <h2 className="mb-4 text-center">{title}</h2> */}
            </div>
          </div>
          
          {/* 右侧：表格 - 在大屏幕占8列，小屏幕占12列 */}
          <div className="col-lg-8 col-md-12">
            <div className="bg-white rounded shadow-sm p-4 border">
              <table className="table table-bordered table-hover">
                <thead className='text-center bg-light'>
                  <tr>
                    <th style={{ width: '30%' }}>Name</th>
                    <th style={{ width: '70%' }}>Affiliation</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMembers.map((member, index) => (
                    <tr 
                      key={index} 
                      className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                      style={{ transition: 'background-color 0.2s ease' }}
                    >
                      <td className='text-center align-middle fw-medium'>
                        {member.name}
                      </td>
                      <td className='align-middle'>
                        {member.affiliation}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center py-10 bg-light rounded shadow-sm border p-5">
          <div className="mb-4">
            <FontAwesomeIcon icon={faNotdef} size="5x" className="text-gray-300" />
          </div>
          <h3 className="text-gray-500 mb-2">In Progress...</h3>
        </div>
      )}
    </div>
  );
};

export default YoungEditorialPage;
